import { mutatorAction } from 'satcheljs';
import getListViewState from '../selectors/getListViewState';
import { isFeatureEnabled } from 'owa-feature-flags';

export const updateStartAndEndIndicesInVLVMutator: (start: number, end: number) => void =
    mutatorAction('updateStartAndEndIndicesInVLVMutator', (start: number, end: number): void => {
        const listViewState = getListViewState();

        // [Not needed for Virtuoso] Subtracting both of these by 1 to account for the pre-rows component which takes index 0 in the VLV.
        // We want these indices to match the indices of the rows in the tableView.rowKeys.
        if (isFeatureEnabled('tri-virtuoso')) {
            listViewState.startIndexVLV = start;
            listViewState.endIndexVLV = end;
        } else {
            listViewState.startIndexVLV = start - 1;
            listViewState.endIndexVLV = end - 1;
        }
    });
